import { useSelector } from 'react-redux';
import { getCurrentFenceGroup } from 'state/fence/fenceSelector';
import ModalStarterSettings from './ModalStarterSettings';
import ModalRemoveFenceGroup from './ModalRemoveFenceGroup';
import ModalAddElement from './ModalAddElement';
import ModalEditElement from './ModalEditElement';
import ModalRemoveElement from './ModalRemoveElement';
import ModalEditRailStyle from './ModalEditRailStyle';

const FenceCanvasModals = () => {
  const modal = useSelector((state) => state.modal);
  const currentFenceGroup = useSelector(getCurrentFenceGroup);
  const settings = currentFenceGroup.settings;

  const renderModal = () => {
    switch (modal.activeName) {
      case 'remove-fence-group':
        return <ModalRemoveFenceGroup />;
      case 'add-element':
        return <ModalAddElement />;
      case 'edit-element':
        return <ModalEditElement />;
      case 'remove-element':
        return <ModalRemoveElement />;
      case 'edit-rail-style':
        return <ModalEditRailStyle />;
      default:
        return null;
    }
  };

  return (
    <>
      {!settings.readyToDesign && <ModalStarterSettings />}
      {renderModal()}
    </>
  );
};

export default FenceCanvasModals;
